import './AnnotationsAtom.css';
export var wrapper = '_nt6wll0-2-0-1';